// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"numbers-8"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M8 12V18C8 18.5523 8.44772 19 9 19H15C15.5523 19 16 18.5523 16 18V12M8 12V6C8 5.44772 8.44772 5 9 5H15C15.5523 5 16 5.44772 16 6V12M8 12H16","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const Numbers8Icon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'numbers-8',
    ref,
    icon: element,
  },
));

Numbers8Icon.displayName = 'Numbers8Icon';

export default Numbers8Icon;
